


















































































































































import { Component } from 'vue-property-decorator';
import { Getter } from "vuex-class";
import { ScrollButton } from "wings-ui-components";
import BaseItemsPage from "@/pages/Pages/BaseItemsPage";
import CallGroupFilter from "@/components/Call/Statistic/CallGroupFilter.vue";
import {CallGroupItem, CallGroupSummary} from '@/store/call/statistic/types';
import GroupCharts from "@/components/Statistics/GroupCharts.vue";

@Component({ components: {CallGroupFilter, ScrollButton, GroupCharts}})
export default class CallGroup extends BaseItemsPage<CallGroupItem> {

  @Getter("callStatisticGroup") responseItems?: CallGroupItem[];
  @Getter("callStatisticGroupSummary") responseSummary?: CallGroupSummary;
  @Getter("callGroupBy") groupByList: any;

  is_show_filter: boolean = true;
  is_show_graphics: boolean = true;

  currentSort: string = "date";

  tableFields = this.tableFieldsDefault;

  group_by: string = '';
  optionally_group_by: string = '';

  onGroupByChange(groupBy: string, optionallyGroupBy: string) {
    this.group_by = groupBy
    this.optionally_group_by = optionallyGroupBy
  }

  print(item: string, totalRow: boolean) {
    if (totalRow) return this.group_by ? '' : this.$t('inAll');
    return item ?? this.$t('unnamed')
  }

  getData(): CallGroupItem[] | undefined {
    return this.responseItems;
  }

  get tableFieldsDefault(): string[] {
    let isShowFinInf: boolean = localStorage.getItem('show-finance-info') === 'true';
    let priceFields = ['partner_price', 'provider_price'];
    return [
      ...['finished', 'not_answered', 'buffered', 'error', 'rejected', 'total', 'duration'],
      ...(isShowFinInf ? priceFields : [])
    ];
  }

  get totalData(): CallGroupItem {
    if (this.responseSummary) {
      return {
        totalRow: 'This is the last row of the table',
        finished: this.responseSummary.finished || 0,
        not_answered: this.responseSummary.not_answered || 0,
        buffered: this.responseSummary.buffered || 0,
        error: this.responseSummary.error || 0,
        rejected: this.responseSummary.rejected || 0,
        duration: this.responseSummary.duration || '00:00:00',
        total: this.responseSummary.total || 0,
        partner_price: this.responseSummary.partner_price || 0,
        provider_price: this.responseSummary.provider_price || 0,
      };
    }

    return {
      totalRow: 'This is the last row of the table',
      finished: 0,
      not_answered: 0,
      buffered: 0,
      error: 0,
      rejected: 0,
      duration: '00:00:00',
      total: 0,
      partner_price: 0,
      provider_price: 0,
    };
  }

  get compareData() {
    return [...this.queriedData, this.totalData];
  }

  formatDuration(val: string): string|undefined {
    if (!val) return undefined;
    return val;
  }
}
